import { Box, Flex } from '@utilitywarehouse/hearth-react';
import { TickSmallIcon } from '@utilitywarehouse/hearth-react-icons';

interface TierRoundelProps {
  reached: boolean;
}

const CHECKBOX_SIZE = '24px';

const TierRoundel = ({ reached }: TierRoundelProps) =>
  reached ? (
    <Flex
      className="welcomeBonus__roundelReached"
      alignItems="center"
      justifyContent="center"
      width={CHECKBOX_SIZE}
      height={CHECKBOX_SIZE}
      borderRadius="full"
    >
      <TickSmallIcon />
    </Flex>
  ) : (
    <Box
      className="welcomeBonus__dashed"
      width={CHECKBOX_SIZE}
      height={CHECKBOX_SIZE}
      borderRadius="full"
      borderWidth="1"
      borderColor="strong"
    />
  );

export { TierRoundel };
